export enum EHttpResponseCode {
  OK = 200,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  METHOD_NOT_ALLOWED = 405,
  ENTITY_TOO_LARGE = 413,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503
}

export enum ECommonResponseCode {
  // network response
  OK = '200',
  BAD_REQUEST = '400',
  UNAUTHORIZED = '401',
  FORBIDDEN = '403',
  SERVER_ERROR = '500',

  S2T_0000 = 'S2T_0000',
  S2T_1000 = 'S2T_1000',
  S2T_1001 = 'S2T_1001',
  S2T_1002 = 'S2T_1002',
  /** Simple To Trade Invalid Password */
  S2T_1003 = 'S2T_1003',
  S2T_1004 = 'S2T_1004',
  S2T_1005 = 'S2T_1005',
  S2T_1006 = 'S2T_1006',
  S2T_1007 = 'S2T_1007',
  S2T_1008 = 'S2T_1008',
  S2T_1009 = 'S2T_1009',
  S2T_1010 = 'S2T_1010',
  S2T_1011 = 'S2T_1011',
  S2T_1012 = 'S2T_1012',
  S2T_1013 = 'S2T_1013',
  S2T_1014 = 'S2T_1014',
  S2T_1015 = 'S2T_1015',

  A_1000 = 'A_1000',
  A_1001 = 'A_1001',
  A_1002 = 'A_1002',
  A_1003 = 'A_1003',
  A_1004 = 'A_1004',
  A_1005 = 'A_1005',
  A_1006 = 'A_1006',
  A_1007 = 'A_1007',
  A_1008 = 'A_1008',
  A_1009 = 'A_1009',
  A_1010 = 'A_1010',
  A_1013 = 'A_1013',
  A_1014 = 'A_1014',
  A_1015 = 'A_1015',
  A_1016 = 'A_1016',
  A_1017 = 'A_1017',
  A_1018 = 'A_1018',
  A_1019 = 'A_1019',
  A_1020 = 'A_1020',
  A_1021 = 'A_1021',
  A_1022 = 'A_1022',
  A_1023 = 'A_1023',
  A_1024 = 'A_1024',
  A_1025 = 'A_1025',
  A_1026 = 'A_1026',
  A_1027 = 'A_1027',
  A_1028 = 'A_1028',
  A_1029 = 'A_1029',
  A_1030 = 'A_1030',
  A_1031 = 'A_1031',
  A_1032 = 'A_1032',
  A_1033 = 'A_1033',
  A_1034 = 'A_1034',
  A_1035 = 'A_1035',
  A_1036 = 'A_1036',
  A_1037 = 'A_1037',
  A_1038 = 'A_1038',
  A_1041 = 'A_1041',
  A_1042 = 'A_1042',
  A_1043 = 'A_1043',
  A_1044 = 'A_1044',
  A_1045 = 'A_1045',
  A_1046 = 'A_1046',
  A_2000 = 'A_2000',

  AQ_0000 = 'AQ_0000',
  AQ_1000 = 'AQ_1000',
  AQ_1001 = 'AQ_1001',

  AX_1001 = 'AX_1001',
  AX_1002 = 'AX_1002',
  AX_1003 = 'AX_1003',
  AX_1004 = 'AX_1004',
  AX_1005 = 'AX_1005',
  AX_1006 = 'AX_1006',
  AX_1008 = 'AX_1008',
  AX_1009 = 'AX_1009',
  AX_1010 = 'AX_1010',
  AX_1011 = 'AX_1011',

  C_MT_0001 = 'C_MT_0001',

  MT4_0000 = 'MT4_0000',
  MT4_1000 = 'MT4_1000',
  MT4_1001 = 'MT4_1001',
  MT4_1002 = 'MT4_1002',
  MT4_1003 = 'MT4_1003',
  MT4_1004 = 'MT4_1004',
  MT4_1005 = 'MT4_1005',
  MT4_1006 = 'MT4_1006',
  MT4_1007 = 'MT4_1007',
  MT4_1008 = 'MT4_1008',
  MT4_1009 = 'MT4_1009',
  /** MetaTrader Invalid Password */
  MT4_1010 = 'MT4_1010',
  MT4_1011 = 'MT4_1011',
  MT4_1012 = 'MT4_1012',
  MT4_1013 = 'MT4_1013',
  MT4_1014 = 'MT4_1014',
  MT4_1015 = 'MT4_1015',
  MT4_1016 = 'MT4_1016',
  MT4_1017 = 'MT4_1017',

  // backoffice error codes
  B_1000 = 'B_1000',
  B_1001 = 'B_1001',
  B_1002 = 'B_1002',
  B_1003 = 'B_1003',
  B_1004 = 'B_1004',
  B_1005 = 'B_1005',
  B_1006 = 'B_1006',
  B_1007 = 'B_1007',
  B_1008 = 'B_1008',

  // 301 = '301', //	FILE_EMPTY
  // 302 = '302', //	FILE_SIZE_EXCEEDED
  // 303 = '303', //	FILE_TYPE_INVALID
  // root admin error codes
  R_1000 = 'R_1000',
  R_1001 = 'R_1001',

  // MT5
  MT5_0000 = 'MT5_0000',
  MT5_1000 = 'MT5_1000',
  MT5_1001 = 'MT5_1001',
  MT5_1002 = 'MT5_1002',
  MT5_10001 = '10001',
  MT5_10002 = '10002',
  MT5_10003 = '10003',
  MT5_10004 = '10004',
  MT5_10005 = '10005',
  MT5_10006 = '10006',
  MT5_10007 = '10007',
  MT5_10008 = '10008',
  MT5_10009 = '10009',
  MT5_10010 = '10010',
  MT5_10011 = '10011',
  MT5_10012 = '10012',
  MT5_10013 = '10013',
  MT5_10014 = '10014',
  MT5_10015 = '10015',
  MT5_10016 = '10016',
  MT5_10017 = '10017',
  MT5_10018 = '10018',
  MT5_10019 = '10019',
  MT5_10020 = '10020',
  MT5_10021 = '10021',
  MT5_10022 = '10022',
  MT5_10023 = '10023',
  MT5_10024 = '10024',
  MT5_10025 = '10025',
  MT5_10026 = '10026',
  MT5_10027 = '10027',
  MT5_10028 = '10028',
  MT5_10029 = '10029',
  MT5_10030 = '10030',
  MT5_10031 = '10031',
  MT5_10032 = '10032',
  MT5_10033 = '10033',
  MT5_10034 = '10034',
  MT5_10035 = '10035',
  MT5_10036 = '10036',
  MT5_10037 = '10037',
  MT5_10038 = '10038',
  MT5_10039 = '10039',
  MT5_10040 = '10040',
  MT5_10041 = '10041',
  MT5_10042 = '10042',
  MT5_10043 = '10043',
  MT5_10044 = '10044',
  MT5_10045 = '10045',
  MT5_10046 = '10046',
  MT5_10047 = '10047',
  MT5_10048 = '10048',
  MT5_10049 = '10049',

  // Centroid
  CTRD_1010 = 'CTRD_1010',
  CTRD_1011 = 'CTRD_1011',

  // Stoneinno CRM Errors

  /** Stoneinno Invalid Password */
  SI_1001 = 'SI_1001',
  SI_1003 = 'SI_1003',
  SI_1006 = 'SI_1006',
  SI_1016 = 'SI_1016',
  SI_1007 = 'SI_1007',
  SI_1017 = 'SI_1017',
  SI_1018 = 'SI_1018',

  // Tradewise
  TW_0000 = 'TW_0000',
  TW_1001 = 'TW_1001',
  TW_1002 = 'TW_1002',
  TW_1003 = 'TW_1003',
  TW_1004 = 'TW_1004',
  TW_1005 = 'TW_1005',
  TW_1006 = 'TW_1006',
  TW_1007 = 'TW_1007',
  TW_1008 = 'TW_1008',
  TW_1009 = 'TW_1009',
  TW_1010 = 'TW_1010',
  // Horizon Codes

  /** Horizon Invalid Password */
  HRZ_1013 = 'HRZ_1013',

  // Pelican Copy Trade
  PW_1001 = 'PW_1001',
  PW_1002 = 'PW_1002',
  PW_1003 = 'PW_1003',
  PW_1004 = 'PW_1004',
  PW_1005 = 'PW_1005',
  PW_1006 = 'PW_1006',
  PW_1007 = 'PW_1007',
  PW_1008 = 'PW_1008',
  PW_1009 = 'PW_1009',
  PW_1010 = 'PW_1010',
  PW_1011 = 'PW_1011',
  PW_1012 = 'PW_1012',
  PW_1013 = 'PW_1013',
  PW_1014 = 'PW_1014',
  PW_1015 = 'PW_1015',
  PW_1016 = 'PW_1016',
  PW_1017 = 'PW_1017',
  PW_1018 = 'PW_1018',
  PW_1019 = 'PW_1019',
  PW_1020 = 'PW_1020',
  PW_1021 = 'PW_1021',
  PW_1022 = 'PW_1022',
  PW_1023 = 'PW_1023',
  PW_1024 = 'PW_1024',
  PW_1025 = 'PW_1025',
  PW_1026 = 'PW_1026',
  PW_1027 = 'PW_1027',
  PW_1028 = 'PW_1028',
  PW_1029 = 'PW_1029',
  /** CRM Errors */
  CRM_1001 = 'CRM_1001'
}
